import { v4 as uuidv4 } from 'uuid';

export const generateFileName = (name: string): string => `${uuidv4()}.${name.split('.').pop() || ''}`;
